<script>

import http from '../core/network/http.js';


function isUp() {
  return http.get('/status/is_up');
}
function serverURL() {
  return http.defaults.baseURL
}
function getRanking () {
  return http.get('/data/ranking')
}
function getRankingABC () {
  return http.get('/data/rankingABC')
}
function generatePLSticker (pl) {
  return http.get('http://192.168.0.98:9019/print/pl/' + pl)
}
function getLastScanSM() {
  return http.get('/api/scan_sm/last')
}
function getPicking() {
  return http.get('/api/sm_picking')
}
function getSupermarket() {
  return http.get('/api/supermarket')
}
function getLastScan(step) {
  return http.get('/api/scan/last/' + step)
}
function getGrid(step) {
  return http.get('/api/grid/' + step)
}
function getStatsAllSteps() {
  return http.get('/api/stats')
}

function getStats(step) {
  return http.get('/api/stats/' + step)
}
function getAvgtimeAndon(step) {
  return http.get('/api/stats/time_andon_picking')
}
function getAllScanKanban(step, params) {
  return http.post('/api/scans/' + step, params)
}
function getAllStockScansFrom(periodInDays) {
  return http.get(`/api/reception/${periodInDays}`)
}
function getAllKanbanCardRatio(params) {
  return http.post('/store/kanbancardratio', params)
}
function getOee() {
  return http.get('/api/oee')
}
function getScanSMByName(name) {
  return http.get('/api/scan_sm/' + name)
}
function getAllScanSMName() {
  return http.get('/api/scan_sm/names')
}
function stopAndon(scanId) {
  return http.get('/api/scan/stop/' + scanId)
}
function getAllScanKanbanReference(step) {
  return http.get('/api/scan/references/all/' + step)
}
function getLastScanKanbanReference(step) {
  return http.get('/api/scan/references/last/' + step)
}
function getAllErrors() {
  return http.get('/api/errors/')
}
function cleanAllErrors() {
  return http.delete('/api/errors/')
}
function getFilteredReferences (params) {
  return http.post('/api/kanban_references/', params)
}
function getKanbanCardByReference (kanban_reference, loop) {
  return http.get('/api/kanban_card/' + kanban_reference + '/' + loop)
}
function getAllKanbanCard (loop) {
  return http.get('/api/kanban_card/' + loop)
}
function postNewCode (code) {
  return http.post('/api/scan_code', code)
}
function getStepByCardId (cardId) {
  return http.get('/api/kanban_card/step/' + cardId)
}
function getRotationSageByKanbanReference (kanban_reference) {
  return http.get('/api/kanban_card/rotation/' + kanban_reference)
}
function generateRotation (kanban_reference) {
  return http.get('/api/generate_rotation_csv/' + kanban_reference)
}
function getInfoPicking () {
  return http.get('api/scan_sm/info')
}
function getKanbanReferenceInfosByKanbanReference (kanban_reference, loop) {
  return http.get('/api/kanban_reference/infos/' + kanban_reference + '/' + loop)
}
function generateDataCSV (loop) {
  return http.get('/api/kanban_card/generate_data_csv/' + loop)
}
function getTemporaryCard (nbrAndons) {
  var params = {'nbrAndons': nbrAndons}
  return http.post('/api/kanban_card/temporary_card', params)
}
function deteteKanbanCard (card_id) {
  return http.post('/api/admin/kanban_card/', card_id)
}
function createReference (reference) {
  return http.post('/api/admin/kanban_reference', reference)
}
function addNewCell (cell_name) {
  return http.post('/api/atelier/add/cell', cell_name)
}
function addScanCell (scan) {
  return http.post('/api/atelier/new_scan', scan)
}
function getAllCells () {
  return http.get('/api/atelier/cells')
}
function getScansCellByCell () {
  return http.get('/api/atelier/scan_cells')
}

function removeKanbanCard(kanban_reference) {
  return http.delete('/api/admin/kanban_reference/' + kanban_reference)
}

function recalculateCardsByKanbanRef(reference, nb_cards, loop) {
  var params = {'reference': reference, 'nb_cards': nb_cards}
  return http.post('/api/kanban_card/' + loop, params)
}

function updateReference(kanban_infos) {
  return http.put('/api/admin/kanban_reference', kanban_infos)
}

function updateEmplacementFromSage(kanban_reference) {
  return http.patch('/api/admin/kanban_reference', {'reference': kanban_reference})
}

function changeReferenceLink(card_id, new_reference) {
  return http.post('/api/change_card_ref', {'card_id': card_id, 'new_reference': new_reference})
}

function changeReferenceRanking(card_id, new_ranking) {
  return http.post('/api/change_reference_ranking', {'card_id': card_id, 'new_ranking': new_ranking})
}

function removeScan(scan_uniqid) {
  return http.delete('/api/scan/' + scan_uniqid)
}

function removeDocumentScan(scan_document_uniqid){
  return http.delete('/api/scan_document/' + scan_document_uniqid)
}

function getAllAndonFifo(nbrAndons){
    var params = {'nbrAndons': nbrAndons}
  return http.post('/api/andon/fifo', params)
}

function getAllAndonUnseenCard(nbrAndons){
  var params = {'nbrAndons': nbrAndons}
  return http.post('/api/andon/unseen', params)
}

function getAllAndonBadErpStock(nbrAndons){
  var params = {'nbrAndons': nbrAndons}
  return http.post('/api/andon/bad_erp_stock', params)
}

function getAllAndonLowStock(nbrAndons){
  var params = {'nbrAndons': nbrAndons}
  return http.post('/api/andon/low_stock', params)
}
function getAndonLowStockForRef(reference){
  return http.get('/api/andon/low_stock/' + reference)
}
function getAndonBadErpStockForRef(reference){
  return http.get('/api/andon/bad_erp_stock/' + reference)
}
function getAndonFifoForRef(reference){
  return http.get('/api/andon/fifo/' + reference)
}
function getAndonUnseenCardForRef(reference){
  return http.get('/api/andon/unseen/' + reference)
}
function getFifoAndonFromCard(cardUid){
  return http.get('/api/andon/fifo/' + cardUid )
}
function getLoops () {
    return http.get('/api/loops')
}
function updateGivenLoop (params) {
    return http.patch('/api/loops', params)
}
function getLoopInformation(LoopName) {
    return http.get('/api/loops/' + LoopName)
}
function getUnseenCardAndonFromCard(cardUid){
  return http.get('/api/andon/unseen/' + cardUid )
}
function getKanbanReferenceStats(reference, loop){
  return http.get('/api/stats/' + reference + '/' + loop )
}
function stopSpecificAndon(baseAndonId) {
  return http.delete('/api/andons/'+ baseAndonId)
}
function getStatsSM() {
  return http.get('/api/statsSM')
}
function getAvgtime (delta) {
  return http.get('/api/stats/time_andon/' + delta)
}
function deleteReferenceFromAndonKanban (reference_id) {
  return http.delete('/api/references/' + reference_id)
}
function getAllBl(reference) {
  return http.get(process.env.ERP_LOADER_URL + '/api/' + process.env.STORE +'/bl/' + reference)
}
function getCardFromReference(reference, loop) {
  return http.get('/api/kanban_references/' + reference + '/' + loop +  '/cards')
}

function addNewRef(params) {
  return http.post('/api/references', params)
}

function sendMail(cf_number, sender) {
  return http.get('/api/supplier/mail/send/' + sender + '/' + cf_number )
}

function getMailFromCF(cf_number) {
  return http.get('/api/supplier/mail/verify/' + cf_number)
}

function getScanTaktCell() {
  return http.get('/api/scans/takt/by_cell')
}

function getWorkstations(loopName){
  return http.get('/api/workstations/loop/' + loopName)
}

function updateWorkstation(loopName, params) {
    return http.post('/api/workstations/loop/' + loopName, params)
}

function createWorkstation(loopName, params) {
    return http.put('/api/workstations/loop/' + loopName, params)
}

function deleteWorkstationItem(loopName, workstationName) {
    return http.delete('/api/workstations/' + workstationName + '/loop/' + loopName)
}
function addNewLoop(params) {
    return http.post('/api/loops', params)
}
function getAllSupplier() {
    return http.get('/api/suppliers')
}

function addSupplier(params) {
    return http.post('/api/suppliers', params)
}

function updateCardSupplier (params) {
    return http.post('/api/kanban_card/supplier', params)
}

function updateLastPrintCard (card_id) {
    return http.put('/api/cards/' + card_id)
}

function printCard(data) {
  let d = {'model': 'KANBAN_SUPPLY_CHAIN_EXTERNAL.lbx',
		   'data': data}
  return http.post(process.env.PRINT_HEURE_URL + '/api/queue/'+process.env.PRINTER_ID, d)
}

function generateRankingExcel (targetedReferences, forXMonths) {
  return http.post('/data/ranking_excel',
                  {'references': targetedReferences,
                   'for_x_months': forXMonths},
                   {
                     responseType: 'blob'
                    })
}

function getKanbanBe() {
  return http.get('/api/kanban_be_card')
}

function addKanbanBe(params){
  return http.put('/api/kanban_be_card', params)
}

function editKanbanBe(card_number, params){
  return http.post('/api/kanban_be_card/'+card_number, params)
}

function cancelKanbanBe(card_number){
  return http.put('/api/kanban_be_card/' + card_number + '/cancel')
}

function printKanbanBe(data) {
  let d = {'model': 'KANBAN_BE_TRELLO.lbx', 'data':data}
  return http.post(process.env.PRINT_HEURE_URL + '/api/queue/' + process.env.PRINTER_ID, d)
}

function createTmpCards(params) {
  return http.post('/api/tmp_kanban_cards', params)
}

function getAllDocuments() {
  return http.get('api/documents')
}

function getDocumentTracking(documentCode) {
  return http.get('/api/documents_infos/' + documentCode)
}

function updateDocument(documentCode, params) {
  return http.post('/api/documents/' + documentCode, params)
}

function getListOfWorkstationsFromLoop (loopName) {
  return http.get('/api/workstations/loop/' + loopName)
}

// function getTodayScansStats () {
//   return http.post('/api/scans/documents/stats/today')
// }

function getTodayScansStats () {
  return http.get('/api/scans/documents/stats/today')
}

function getYesterdayScansStats () {
  return http.get('/api/scans/documents/stats/yesterday')
}

function getScansStats (graph, days, offset = 0) {
  return http.post('/api/scans/documents/stats/graph', {days, graph, offset})
}

function getScanFromLoop (loop) {
  return http.get('/api/scans/documents/' + loop)
}

function getScanFromLoopAsync (loop, params) {
  return http.post('/api/scans/documents/' + loop, params)
}

function scanDocument (params) {
  return http.post('/api/scans/documents/', params)
}

function getScanDocumentExcel (loop) {
  return http.post('api/scans/documents/export_excel/' + loop,
    {},
    {
      responseType: 'blob',
    },
  )
}

function getAllDocumentsInfo() {
  return http.get('/api/documents_infos')
}

function getLoopStats(loopName) {
  return http.get('/api/loops/' + loopName + '/stats')
}

function getRedbinThalesStats(loopName) {
  return http.get('/api/redbin/thales/stats')
}

function getScanDocumentAndon(documentCode) {
  return http.get('/api/andons/scan/' + documentCode)
}

function getScanAndon(AndonReference) {
  return http.get('/api/scans/cards/' + AndonReference)
}

function getLastCardConsumed(referenceCode) {
  return http.get('/api/last_card_consumed/' + referenceCode)
}

function addScanDocumentAndon(documentCode) {
  return http.post('/api/andons/scan/' + documentCode)
}

function addWorkstationAndon(loop_name, workstation_name, params) {
  return http.post('api/andons/' + loop_name + '/' + workstation_name, params)
}

function getDocumentFromRedBin() {
  return http.get('api/documents/redbin')
}

function createDocument (form) {
  return http.put('api/documents', form)
}

function getActions (loopId) {
  return http.get(`api/actions/loops/${loopId}`)
}

function addActions (params, loopId) {
  return http.put(`api/actions/loops/${loopId}`, params)
}

function deleteAction (actionId) {
  return http.delete(`api/actions/${actionId}`)
}

function stopDocument (code) {
  return http.put('api/stop_document/' + code)
}

function getLastKanbanCardId (cardId) {
  return http.get('/api/kanban_card/last/' + cardId)
}

function blockDocument(code) {
  return http.post('api/block_document/' + code)
}

function unblockDocument(code) {
  return http.post('api/unblock_document/' + code)
}

function sendDocumentComment (documentCode, comment) {
  return http.put(`/api/documents/${documentCode}/comment`, {comment})
}

function getDocumentComment (documentCode) {
  return http.get(`/api/documents/${documentCode}/comment`)
}

function deleteComment (uniqid) {
    return http.delete(`/api/comment/${uniqid}`)
}

function computeLeadtimeMeanOnPeriod(params) {
  return http.post('api/kanban_be_card/leadtime', params)
}

function getDocumentByGex(code_gex){
    return http.get(`api/documents_code_gex/${code_gex}`)
}

export default {
  addNewRef,
  isUp,
  sendDocumentComment,
  getLastKanbanCardId,
  generateRankingExcel,
  getKanbanReferenceStats,
  getFifoAndonFromCard,
  getUnseenCardAndonFromCard,
  getKanbanCardByReference,
  getLastScan,
  getLastScanSM,
  getGrid,
  getStats,
  getOee,
  getScanAndon,
  getPicking,
  getSupermarket,
  getAvgtimeAndon,
  getScanSMByName,
  getAllScanSMName,
  stopAndon,
  getAllScanKanban,
  getAllStockScansFrom,
  getAllScanKanbanReference,
  getLastScanKanbanReference,
  cleanAllErrors,
  getAllErrors,
  getAllKanbanCard,
  postNewCode,
  getTemporaryCard,
  getStepByCardId,
  getRotationSageByKanbanReference,
  generateRotation,
  getInfoPicking,
  getKanbanReferenceInfosByKanbanReference,
  generateDataCSV,
  deteteKanbanCard,
  createReference,
  addNewCell,
  addScanCell,
  getAllCells,
  getScansCellByCell,
  removeKanbanCard,
  updateReference,
  updateEmplacementFromSage,
  getFilteredReferences,
  recalculateCardsByKanbanRef,
  changeReferenceRanking,
  changeReferenceLink,
  removeScan,
  getAllKanbanCardRatio,
  getAllAndonFifo,
  getAllAndonUnseenCard,
  getAllAndonLowStock,
  getAllAndonBadErpStock,
  getCardFromReference,
  getAndonLowStockForRef,
  getAndonFifoForRef,
  getAndonUnseenCardForRef,
  getAndonBadErpStockForRef,
  stopSpecificAndon,
  getStatsSM,
  getAvgtime,
  deleteReferenceFromAndonKanban,
  serverURL,
  generatePLSticker,
  getAllBl,
  getStatsAllSteps,
  getRanking,
  getRankingABC,
  sendMail,
  getMailFromCF,
  getScanTaktCell,
  getLoops,
  getLoopInformation,
  updateGivenLoop,
  getWorkstations,
  updateWorkstation,
  deleteWorkstationItem,
  addNewLoop,
  getAllSupplier,
  addSupplier,
  updateCardSupplier,
  printCard,
  getKanbanBe,
  addKanbanBe,
  editKanbanBe,
  printKanbanBe,
  createTmpCards,
  getAllDocuments,
  getDocumentTracking,
  getListOfWorkstationsFromLoop,
  getTodayScansStats,
  getYesterdayScansStats,
  getScansStats,
  getScanFromLoop,
  getScanFromLoopAsync,
  getAllDocumentsInfo,
  getLoopStats,
  getScanDocumentAndon,
  addScanDocumentAndon,
  addWorkstationAndon,
  getDocumentFromRedBin,
  createDocument,
  updateLastPrintCard,
  stopDocument,
  scanDocument,
  getScanDocumentExcel,
  updateDocument,
  createWorkstation,
  getActions,
  addActions,
  deleteAction,
  getRedbinThalesStats,
  blockDocument,
  unblockDocument,
  computeLeadtimeMeanOnPeriod,
  getDocumentComment,
  deleteComment,
  cancelKanbanBe,
  getDocumentByGex,
  getLastCardConsumed,
  removeDocumentScan
}
</script>



// WEBPACK FOOTER //
// src/api/server.vue